'use strict';
const angular = require('angular');
import ServiceResource from './service.resource';
import OfferResource from './offer.resource';
import ProductResource from './product.resource';
import AssistantResource from './assistant.resource';
import ShopResource from './shop.resource';
import DailyReportResource from './dailyReport.resource';
import ConfigurationsResource from './configurations.resource';

export default angular.module('nomasvelloDashboardApp.resources', [
    
])
    .factory('Service', ServiceResource)
    .factory('Offer', OfferResource)
    .factory('Product', ProductResource)
    .factory('Assistant', AssistantResource)
    .factory('Shop', ShopResource)
    .factory('DailyReport', DailyReportResource)
    .factory('DailyReport', DailyReportResource)
    .factory('Configurations', ConfigurationsResource)
    .name;



// WEBPACK FOOTER //
// ./client/components/resources/index.ts